import { OrderType } from 'global-constants';

export interface OrderSurveyData {
  orderNumber: string;
  orderType: OrderType;
  organization: string;
}

export interface DelightedSurveyProperties {
  orderNumber: string;
  orderType: string;
  organization: string;
  [key: string]: string;
}

export interface DelightedSurveyCall {
  email: string;
  name: string;
  properties: DelightedSurveyProperties;
}

export const ORDER_TYPE_TO_SURVEY_MAPPING: Record<OrderType, string> = {
  [OrderType.PROCUREMENT_TO_RECIPIENT]: 'Procurement to Recipient',
  [OrderType.PROCUREMENT_TO_DEPOT]: 'Procurement to Depot',
  [OrderType.DEPLOYMENT]: 'Deployment',
  [OrderType.RETRIEVAL]: 'Retrieval',
  [OrderType.BULK_RETRIEVAL]: 'Bulk Retrieval',
  [OrderType.DROP_RETRIEVAL]: 'Drop Retrieval',
  [OrderType.PROCESS]: 'Process',
  [OrderType.RECYCLE]: 'Recycle',
  [OrderType.REPAIR]: 'Repair',
  [OrderType.RESELL]: 'Resell',
  [OrderType.DEVICE_UNLOCK]: 'Device Unlock',
}; 
